import React, { useState, useEffect, useCallback, useContext } from "react";
import styled from "styled-components";
import Logo from "../../SVGs/Logo.svg";
import Logout from "../../SVGs/Logout.svg";
import { NavLink } from "react-router-dom";
import { UserContext } from "../../Context/user_context";
import UserIcon from "../../SVGs/UserIcon.svg";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

function Nav() {
  const { user, setUser } = useContext(UserContext);
  const navigation = useNavigate();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Update window width on resize
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSignout = useCallback(() => {
    Cookies.remove("hippocratic_portal_contactid");
    Cookies.remove("hippocratic_portal_token");
    setUser(null);
    navigation("/");
  }, [setUser, navigation]);

  return (
    <Container>
      <NavLink to="/">
        <LeftContainer>
          <LogoIcon src={Logo} alt="App Name" />
          <LogoName>Hippocratic Portal</LogoName>
        </LeftContainer>
      </NavLink>
      <RightContainer>
        {!user && (
          <>
            <CustomNavLink to="/Login">
              <Flex>
                <Text>Sign In</Text>
                <img src={Logout} alt="Logout" />
              </Flex>
            </CustomNavLink>
          </>
        )}
        {user && (
          <>
            <CustomNavLink to="/Overview">
              <Flex>
                <img src={UserIcon} alt="User Icon" />
                <Text>{user.fullname}</Text>
              </Flex>
            </CustomNavLink>
            <Seperator />
            <CustomNavLink as="div" onClick={handleSignout}>
              <Flex>
                <Text>Sign Out</Text>
                <img src={Logout} alt="Logout" />
              </Flex>
            </CustomNavLink>
          </>
        )}
      </RightContainer>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 3vh 5vw;
  margin-bottom: 5vh;
  background-color: var(--darkBlue);
  max-width: 100vw;
  height: 15vh;

  box-sizing: border-box;
`;

const LeftContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

const RightContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  @media screen and (max-width: 984px) {
    display: none;
  }
`;

const Text = styled.div`
  color: var(--offWhite);
  font-family: "Museo Sans Cyrl";
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 80% */
`;

const Flex = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-contnet: center;
  gap: 8px;
`;

const Seperator = styled.div`
  width: 1.5px;
  height: 25px;
  border-radius: 10px;
  background-color: var(--white);
`;

const CustomNavLink = styled(NavLink)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LogoName = styled.div`
  color: #fff;
  font-family: Georgia;
  font-size: 32.759px;
  font-style: normal;
  font-weight: 400;
  line-height: 90%; /* 29.483px */
  letter-spacing: -0.655px;

  @media screen and (max-width: 475px) {
    font-size: 26px;
  }
  @media screen and (max-width: 389px) {
    font-size: 18px;
  }
`;

const LogoIcon = styled.img`
  @media screen and (max-width: 479px) {
    width: 50px;
  }
`;

export default Nav;
